import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import { academyDataActions } from '../../../store/academy-slice';

import {
  getAccesCourse,
  getCourseAditionalInfo,
  getCourseInfo,
  getCourseReviews,
  getDegree,
  getLessonsByCourse,
  getMissingActivities,
  getTrailerCourseInfo,
  getUserAditionalTrackCourse,
  getUsersInCourse
} from 'store/course-actions';

import {
  confirmNameValidate,
  getValidationName
} from 'store/user-actions';

import Loading from 'components/UI/Loading/Loading';

import CourseTop from './CourseTop/TopSection/CourseTop';
import CourseSpecificInfo from './CourseSpecificInfo/CourseSpecificInfo';
import CourseBottom from './CourseBottom/CourseBottom';
import BreadCrumbs from 'components/UI/BreadCrumbs/BreadCrumbs';
import ValidateName from './ValidateName/ValidateName';

import classes from './CoursePage.module.css';

const url = window.location.pathname.split('/');

const CoursePage = props => {
  const dispatch = useDispatch();
  const [loadData, setLoadData] = useState(false);
  const [actuallyIdCourse, setActuallyIdCourse] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [openValidationName, setOpenValidationName] =
    useState(false);
  const dataCourse = useSelector(state => state.courseInfo);
  const dataAcademy = useSelector(state => state.academyInfo);
  const userInfo = useSelector(state => state.userInfo);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);

  useEffect(() => {
    if (!loadData && dataAcademy.data.idAcademy) {
      dispatch(getCourseInfo(props.idCourse));
      dispatch(getValidationName(props.idCourse));
      dispatch(getCourseAditionalInfo(props.idCourse));
      dispatch(getUsersInCourse(props.idCourse));
      dispatch(getUserAditionalTrackCourse(props.idCourse));
      dispatch(getLessonsByCourse(props.idCourse));
      dispatch(getCourseReviews(props.idCourse));
      dispatch(getDegree(props.idCourse));
      dispatch(getMissingActivities(props.idCourse));
      if (dataAcademy.data.idAcademy) {
        dispatch(
          getTrailerCourseInfo(
            dataAcademy.data.idAcademy,
            props.idCourse
          )
        );
        dispatch(
          getAccesCourse(props.idCourse, dataAcademy.data.idAcademy)
        );
      }
      setLoadData(true);
    }
  }, [props.idCourse, dataAcademy.data]);

  useEffect(() => {
    if (
      dataCourse.data.emisor &&
      dataCourse.aditionalData.name &&
      dataCourse.userAditionalTrack.userTrack &&
      dataCourse.lessonsCourse.lessonExtraInfo &&
      dataCourse.courseReviews.reviewsStars &&
      dataCourse.missingActivities
    ) {
      setActuallyIdCourse(dataCourse.data.idLista);
    }
  }, [
    dataCourse.data,
    dataCourse.aditionalData,
    dataCourse.userAditionalTrack,
    dataCourse.lessonsCourse,
    dataCourse.courseReviews,
    dataCourse.missingActivities
  ]);

  useEffect(() => {
    if (
      dataCourse.accessCourse === false &&
      dataAcademy.data.isOpen === 0
    ) {
      window.location.href = `/${dataAcademy.data.shortName}/disabled`;
    }
  }, [dataCourse.accessCourse, dataAcademy.isOpen]);

  useEffect(() => {
    if (props.idCourse == actuallyIdCourse) {
      setIsLoading(false);
    }
  }, [props.idCourse, actuallyIdCourse]);

  useEffect(() => {
    if (userInfo.data.usuario) {
      if (
        !userInfo.validationName &&
        userInfo.validationName !== null
      ) {
        setOpenValidationName(true);
      }
    }
  }, [userInfo]);

  const confirmNameHandler = () => {
    (async () => {
      const confirmNameData = await confirmNameValidate(
        props.idCourse
      );
      if (confirmNameData) {
        setOpenValidationName(false);
      }
    })();
  };

  return (
    <>
      {!isLoading ? (
        dataCourse.aditionalData.authorized === 1 ? (
          <section className={classes.coursePageContainer}>
            {url[2] !== 'course' && (
              <BreadCrumbs title={dataCourse.data.nombre} />
            )}
            <CourseTop dataCourse={dataCourse} />
            <CourseSpecificInfo dataCourse={dataCourse} />
            <CourseBottom
              dataCourse={dataCourse}
              ltiData={props.ltiData}
            />
            <ValidateName
              open={openValidationName}
              confirmName={confirmNameHandler}
            />
          </section>
        ) : (
          <div className={classes.noCourseContainer}>
            <p className={classes.title}>
              Esta versión del curso ya no se encuentra disponible
            </p>
            <p className={classes.subtitle}>
              Pero no te preocupes. Puedes ver la lista actualizada
              de cursos regresando al inicio de la academia.
            </p>
            <Button
              component={Link}
              to="/"
              className={classes.btnHome}
            >
              Inicio
            </Button>
          </div>
        )
      ) : (
        <Loading />
      )}
    </>
  );
};

CoursePage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  ltiData: PropTypes.object
};

export default CoursePage;
